import React from "react";

// Animated GIFs
import gif1 from "../../images/icon/original-66948a0d81d.gif";
import gif2 from "../../images/icon/0deec720000b2066289b.gif";
import gif3 from "../../images/icon/b10c3e43e836d32554bf.gif";


const AboutSection: React.FC = () => {
  return (
    <section className="about pt-140 pb-140">
      <div className="container">
        <div className="sec-title about-sec-title mb-75">
          <span className="sub-title">Who We Are</span>
          <h2 className="title">
            We run a
            <span>
              <img src={gif1} alt="animation" />
            </span>{" "}
            cheap SMM panel for creators and
            <span>
              <img src={gif2} alt="animation" />
            </span>
            resellers. Real services, low prices, fast delivery.{" "}
            <span>
              <img src={gif3} alt="animation" />
            </span>
          </h2>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
